import { ApiDefinition } from "./ApiDefinition";
import { APIPromise } from "../services/HttpService";
import { DatasetStringValueMapperDTO } from "components/dashboard/charts/interfaces";
import { stringify } from "querystring";

class DatasetMappersApiDefinition extends ApiDefinition {
  constructor() {
    super("/dataset-mappers");
  }

  async getAll(): APIPromise<any> {
    return this.get(null);
  }

  async getById(id: string): APIPromise<any> {
    return this.get(`${id}`);
  }

  async create(data: DatasetStringValueMapperDTO): APIPromise<any> {
    return this.post(null, data);
}


  async update(id: string, data: DatasetStringValueMapperDTO): APIPromise<any> {
    return this.put(`${id}`, data);
  }
  async remove(id: string): APIPromise<any> {
    return this.delete(`${id}`);
  }
}

export const DatasetMappersApi = new DatasetMappersApiDefinition();
